import { useEffect, useState } from "react";

export default function ShareBar({ className = "" }: { className?: string }) {
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!message) return;
    const timer = window.setTimeout(() => setMessage(""), 2600);
    return () => window.clearTimeout(timer);
  }, [message]);

  const handleCopy = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      setMessage("链接已复制到剪贴板");
    } catch {
      const input = document.createElement("input");
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      setMessage("链接已复制到剪贴板");
    }
  };

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      <span className="text-xs text-foreground-500 mr-1">分享</span>
      <button
        type="button"
        onClick={handleCopy}
        className="inline-flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-link"></i>
        复制链接
      </button>
      <button
        type="button"
        onClick={() => setMessage("社交平台分享为演示功能，暂未接入真实接口")}
        aria-label="分享到微博（演示）"
        title="演示功能"
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
      >
        <i className="ri-weibo-line"></i>
      </button>
      <button
        type="button"
        onClick={() => setMessage("社交平台分享为演示功能，暂未接入真实接口")}
        aria-label="分享到微信（演示）"
        title="演示功能"
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
      >
        <i className="ri-wechat-line"></i>
      </button>
      {message && (
        <span className="text-xs text-accent-600 bg-accent-50 border border-accent-100 rounded-md px-2.5 py-1.5 animate-fade">
          {message}
        </span>
      )}
    </div>
  );
}